module.exports = __webpack_public_path__ + "img/b95aff3.jpg";